export default {
  data: { data: [], current_page: 1, last_page: 1, total: 0 },
  options: { accommodation_types: [], amenities: [], locations: [] },
};
